// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__XwOmY","title":"Images45_title__1prsL","images":"Images45_images__29y1t"};